import { SECTION_CODE_ACCORDING_TO_CLASSIFICATION } from "@frontend/common/src/constants/articleSection";
import * as Sentry from "@sentry/react";
import { AxiosError } from "axios";

import { getArticleInfoData } from "@api/articleInfo/useArticleInfo";
import { articlePublishApis } from "@services/articlePublish.service";
import { getPressIdFromURL } from "@utils/getStateFromURL";
import { toastFail } from "@utils/toast";

export const usePublish = () => {
  const articleInfo = getArticleInfoData();
  const classification = articleInfo?.data.classificationManual || "";
  const articleSectionType =
    SECTION_CODE_ACCORDING_TO_CLASSIFICATION[classification];

  const publish = async () => {
    try {
      const response = await articlePublishApis.post(
        getPressIdFromURL(),
        articleSectionType,
      );

      if (response.code !== 200) {
        // NOTE : 90003 에러가 발생하는 경우(error로 잡히지 않은 경우), 원인 확인 BE팀과 필요
        toastFail("Failed to publish article.", "bottomLeft");
        Sentry.captureMessage(
          `[#${getPressIdFromURL()}] Failed to publish article.`,
          {
            level: "error",
            tags: {
              pressId: getPressIdFromURL(),
              type: "failed-to-publish-article",
            },
            extra: {
              title: `[#${getPressIdFromURL()}] Failed to publish article.`,
              code: response.code,
              message: response.message,
              draftArticleId: getPressIdFromURL(),
            },
          },
        );
      }
      return response.data;
    } catch (error) {
      const currentError = error as AxiosError;
      toastFail("Failed to publish article.", "bottomLeft");
      Sentry.captureMessage(
        `[#${getPressIdFromURL()}] Failed to publish article.`,
        {
          level: "error",
          tags: {
            pressId: getPressIdFromURL(),
            type: "failed-to-publish-article",
          },
          extra: {
            title: `[#${getPressIdFromURL()}] Failed to publish article.`,
            errorStatus: currentError.response?.status,
            errorCode: currentError.code,
            errorMessage: currentError.message,
            errorResponse: currentError.request.response,
            draftArticleId: getPressIdFromURL(),
          },
        },
      );
    }
  };

  return publish;
};
